import script from "./LiveUpdateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveUpdateModal.vue?vue&type=script&setup=true&lang=js"

import "./LiveUpdateModal.vue?vue&type=style&index=0&id=559ed8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559ed8c0"]])

export default __exports__